import type { BrandingConfig } from "./types";

/**
 * Utilifeed default branding.
 * Used as fallback when an organization has no branding configured.
 */
export const DEFAULT_BRANDING: BrandingConfig = {
  colors: {
    primary: "#3F5F90",
    secondary: "#FFDBC8",
    tertiary: "#D63B6A",
    primaryDark: "#003062",
    primaryLight: "#2F77D2",
    surface: "#F9F9FF",
    container: "#F3F3FA",
    fontPrimary: "#191C20",
    fontSecondary: "#5A5E66",
    fontInverted: "#FFFFFF",
    card: "#FFFFFF",
    divider1: "#C4C6CF",
    divider2: "#E2E2E9",
    inverseSurface: "#2E3035",
    outline: "#74777F",
  },
  logos: {
    light: "/logo-white.png",
    dark: "/utilifeed.svg",
    favicon: "/favicon.ico",
  },
  typography: {
    fontFamily: "Public Sans, Arial, sans-serif",
  },
  text: {
    appTitle: "Utilifeed",
    seoDescription: "Utilifeed - Smart energy management",
    companyName: "Utilifeed",
  },
  graphColors: {
    graph1: "#D63B6A",
    graph2: "#2F77D2",
    graph3: "#FF8D3C",
    graph4: "#007078",
    graph5: "#6E4198",
    graph6: "#24C1C7",
    graph7: "#67C188",
    graph8: "#AFB151",
    graph9: "#616000",
    graph10: "#BD97E7",
  },
  urls: {
    website: "https://www.utilifeed.com",
  },
  preferences: {
    PropAIenergyprefix: "",
  },
};
